import { FC } from 'react';

import AppLayout, { LayoutProps, Link } from 'app/components/layout/AppLayout';
import { factorRoutes, routes } from 'app/constants/routes';
import { useQueryString } from 'app/state/NavigationContext/hooks';

// Component Definition
const FactorRoutesLayout: FC<LayoutProps> = props => {
  const invoicesQueryString = useQueryString('factorInvoices');
  const loadsQueryString = useQueryString('factorLoads');
  const paymentsQueryString = useQueryString('factorPayments');
  const relationshipsQueryString = useQueryString('factorPayees');
  const payorsQueryString = useQueryString('factorPayors');

  const links: Link[] = [
    {
      activePaths: [`/${routes.factor}/${factorRoutes.payors}`],
      iconName: 'business',
      id: 'debtors',
      label: 'Debtors',
      to: `/${routes.factor}/${factorRoutes.payors}${payorsQueryString}`,
    },
    {
      activePaths: [`/${routes.factor}/${factorRoutes.payeeRelationships}`],
      iconName: 'person',
      id: 'clients',
      label: 'Clients',
      to: `/${routes.factor}/${factorRoutes.payeeRelationships}${relationshipsQueryString}`,
    },
    {
      activePaths: [`/${routes.factor}/${factorRoutes.loads}`],
      iconName: 'truck',
      id: 'loads',
      label: 'Loads',
      to: `/${routes.factor}/${factorRoutes.loads}${loadsQueryString}`,
    },
    {
      activePaths: [`/${routes.factor}/${factorRoutes.invoices}`],
      iconName: 'file',
      id: 'invoices',
      label: 'Invoices',
      to: `/${routes.factor}/${factorRoutes.invoices}${invoicesQueryString}`,
    },
    {
      activePaths: [`/${routes.factor}/${factorRoutes.payments}`],
      iconName: 'money',
      id: 'payments',
      label: 'Payments',
      to: `/${routes.factor}/${factorRoutes.payments}${paymentsQueryString}`,
    },
  ];

  return (
    <AppLayout
      body={props.body}
      logoPath={`/${routes.factor}/${factorRoutes.payors}${payorsQueryString}`}
      navLinks={links}
    />
  );
};

export default FactorRoutesLayout;
